import { render, staticRenderFns } from "./ContractsStartShipment.vue?vue&type=template&id=ab283556&scoped=true&"
import script from "./ContractsStartShipment.vue?vue&type=script&lang=js&"
export * from "./ContractsStartShipment.vue?vue&type=script&lang=js&"
import style0 from "./ContractsStartShipment.vue?vue&type=style&index=0&id=ab283556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab283556",
  null
  
)

export default component.exports